import { all } from 'redux-saga/effects';

export default function* exampleSaga() {
  yield all([]);
}
